import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import GetRecordTemplates
                                                    from "../../../application/usecase/record/template/GetRecordTemplates";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import RecordTemplateAddButton                      from "../../components/record/template/RecordTemplateAddButton";
import RecordTemplateList                           from "../../components/record/template/RecordTemplateList";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  getRecordTemplates: GetRecordTemplates;
}

class RecordTemplatesContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "記録テンプレート一覧"
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getRecordTemplates.execute();
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "記録テンプレート一覧",
                path: "/record/templates"
              },
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>
        <TopSection>
          <BackHistoryButton path="/setting"/>
        </TopSection>
        <TopSection>
          <RecordTemplateAddButton/>
        </TopSection>
        <RecordTemplateList/>
      </>
    );
  }


}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getRecordTemplates: new GetRecordTemplates(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordTemplatesContainer);